import { useHeaderData } from '../model';
import { HeaderLogo } from './header-logo';
import { HeaderUserProfile } from './header-user-profile';

export function AppHeader() {
	const { user } = useHeaderData();

	return (
		<header className="w-full bg-brand-white border-b border-gray-200">
			<div className="container mx-auto px-4 py-3 md:px-8 md:py-4">
				<div className="flex items-center justify-between">
					{/* Left: Logo and Brand */}
					<HeaderLogo />

					{/* Right: User Profile */}
					<div className="flex items-center gap-6">
						<HeaderUserProfile user={user} />
					</div>
				</div>
			</div>
		</header>
	);
}
